<template>
    <section v-if="email && reportStore.reports[email].isReportFetch">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="$router.go(-1)" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="row match-height">
                            <div class="col-xl-12 col-lg-12">
                                <div class="card">
                                    <div v-if="creditorRefs.length > 0" class="card-body">
                                        <div class="row">
                                            <div class="col-md-3 col-12"  v-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_3 || $route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_2 || $route.params.letter == letterStore.COLLECTION_DISPUTE_LETTER_1_A">
                                                <div class="form-group">
                                                    <label for="odate">
                                                        Sent On Date One
                                                    </label>
                                                    <input
                                                        type="date"
                                                        v-model="originalCreditedDate"
                                                        class="form-control"
                                                        name="originalCreditedDate"
                                                        @change="updateLetter()"
                                                        :class="{'is-invalid' : false}"
                                                    />
                                                    <span v-if="false" class="invalid-feedback" role="alert">
                                                        <strong>Field is Required</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-12"  v-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_3">
                                                <div class="form-group">
                                                    <label for="odate" v-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_3">
                                                        Sent On Date Two
                                                    </label>
                                                    <input
                                                        type="date"
                                                        v-model="originalCreditedDateTwo"
                                                        class="form-control"
                                                        name="originalCreditedDateTwo"
                                                        @change="updateLetter()"
                                                        :class="{'is-invalid' : false}"
                                                    />
                                                    <span v-if="false" class="invalid-feedback" role="alert">
                                                        <strong>Field is Required</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-12"  v-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_3">
                                                <div class="form-group">
                                                    <label for="odate" v-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_3">
                                                        Response Date
                                                    </label>
                                                    <input
                                                        type="date"
                                                        v-model="responseDate"
                                                        class="form-control"
                                                        name="responseDate"
                                                        @change="updateLetter()"
                                                        :class="{'is-invalid' : false}"
                                                    />
                                                    <span v-if="false" class="invalid-feedback" role="alert">
                                                        <strong>Field is Required</strong>
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                v-if="lodash.includes([letterStore.CREDITOR_REPOSSESSION_LETTER_4], $route.params.letter)"
                                                class="col-xl-2 col-md-2 col-12"
                                            >
                                                <label for="update-letter-content"></label>
                                                <div class="form-group">
                                                    <button class="btn btn-sm-block btn-primary" @click="openModal('#letter-form');" type="button">
                                                        Update Letter
                                                    </button>
                                                </div>
                                            </div>
                                            <div
                                                v-if="lodash.includes([letterStore.REPOSSESSION_LETTER_1], $route.params.letter)"
                                                class="col-xl-2 col-md-2 col-12"
                                            >
                                                <label for="update-letter-content"></label>
                                                <div class="form-group">
                                                    <button class="btn btn-sm-block btn-primary" @click="openModal('#repossession-form');" type="button">
                                                        Update Letter
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="col-xl-3 col-md-3 col-12">
                                                <h4>APPEND CLIENT DOCUMENTS</h4>
                                                <div class="display-box mb-1">
                                                    <div class="ml-2">
                                                        <input
                                                            class="custom-control-input"
                                                            type="checkbox"
                                                            name="append_affidavit"
                                                            value="1"
                                                            tabindex="4"
                                                            v-model="checkbox"
                                                            id="append_affidavit"

                                                        />
                                                        <label class="custom-control-label" for="Make_the_recipient_the_sender" @click="changeCheckbox">
                                                            ID Theft Affidavit
                                                        </label>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                        <div
                                            v-if="$route.params.letter == letterStore.CREDITOR_ATTORNEY_GENERAL_LETTER_1"
                                            class="row d-flex align-items-end"
                                        >
                                            <div class="col-lg-2 col-md-2 col-12">
                                                <div class="form-group">
                                                    <label for="attorney-general-state">
                                                        Your State Attorney General
                                                    </label>
                                                    <input
                                                        @input="updateLetter()"
                                                        v-model="attorneyGeneral.name"
                                                        type="text"
                                                        class="form-control"
                                                        id="attorney-general-state"
                                                        name="attorney-general-state"
                                                        placeholder="Your State Attorney General"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-12">
                                                <div class="form-group">
                                                    <label for="consumer-division-name">
                                                        Consumer Division Name
                                                    </label>
                                                    <input
                                                        @input="updateLetter()"
                                                        v-model="consumerDivisionName"
                                                        type="text"
                                                        class="form-control"
                                                        id="consumer-division-name"
                                                        name="consumer-division-name"
                                                        placeholder="Consumer Division Name"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-12">
                                                <div class="form-group">
                                                    <label for="attorney-general-address">
                                                        Attorney General Address
                                                    </label>
                                                    <input
                                                        @input="updateLetter()"
                                                        v-model="attorneyGeneral.address"
                                                        type="location"
                                                        class="form-control required"
                                                        id="attorney-general-address"
                                                        name="attorney-general-address"
                                                    />
                                                </div>
                                            </div>

                                            <div class="col-lg-2 col-md-2 col-12">
                                                <div class="form-group">
                                                    <label for="attorney-general-city">
                                                        City
                                                    </label>
                                                    <input
                                                        @input="updateLetter()"
                                                        v-model="attorneyGeneral.city"
                                                        type="text"
                                                        class="form-control required"
                                                        id="attorney-general-city"
                                                        name="attorney-general-city"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-12">
                                                <div class="form-group">
                                                    <label for="attorney-general-state">
                                                        State
                                                    </label>
                                                    <input
                                                        @input="updateLetter()"
                                                        v-model="attorneyGeneral.state"
                                                        type="text"
                                                        class="form-control required"
                                                        id="attorney-general-state"
                                                        name="attorney-general-state"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-12">
                                                <div class="form-group">
                                                    <label for="attorney-general-zipcode">
                                                        Zipcode
                                                    </label>
                                                    <input
                                                        @input="updateLetter()"
                                                        v-model="attorneyGeneral.zipcode"
                                                        type="text"
                                                        class="form-control"
                                                        id="attorney-general-zipcode"
                                                        name="attorney-general-zipcode"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-12">
                                                <div class="form-group">
                                                    <label for="attorney-general-fax">
                                                        FAX
                                                    </label>
                                                    <input
                                                        @input="updateLetter()"
                                                        v-model="attorneyGeneral.fax"
                                                        type="text"
                                                        class="form-control"
                                                        id="attorney-general-fax"
                                                        name="attorney-general-fax"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <ul class="nav nav-tabs nav-justified" role="tablist">
                                            <li v-for="(creditor, key) in creditors" :ref="creditor.ref" class="nav-item">
                                                <a
                                                    class="nav-link"
                                                    :class="{ active: activeTab == key}"
                                                    @click="activeTab = key"
                                                >
                                                    {{ creditor.creditor.creditor_name }}
                                                </a>
                                            </li>
                                        </ul>
                                        <!-- Tab panes -->
                                        <div class="tab-content pt-1">
                                            <div
                                                class="tab-pane active"
                                                role="tabpanel"
                                            >
                                                <div v-for="(creditor, key) in creditors" v-show="activeTab == key">
                                                    <editor
                                                        :id="key"
                                                        v-model="creditor.ref"
                                                        :api-key="settingStore.tinymce.api_key"
                                                        :init="settingStore.tinymce.configuration"
                                                    />
                                                </div>
                                                <div class="d-flex justify-content-center my-1">
                                                    <button class="btn btn-sm-block btn-primary" @click.once="submit" type="button" name="editorType" value="1">
                                                        {{ localizationStore.translate("letter.left.submit.button.text") }}
                                                    </button>
                                                    <button
                                                        id="letter-rewrite"
                                                        class="btn btn-outline-primary ml-1"
                                                        @click="spin"
                                                        type="button"
                                                    >
                                                        {{ localizationStore.translate("spin.letter.button.text") }}
                                                        <b-popover
                                                            target="letter-rewrite"
                                                            placement="top"
                                                            triggers="hover"
                                                            :html="true"
                                                        >
                                                            <template #title>
                                                                {{ localizationStore.translate("chat.pricing.title") }}
                                                            </template>
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                                        {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('letter_rewrite') }) }}
                                                                    </p>
                                                                    <p v-else>
                                                                        {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </b-popover>
                                                    </button>
                                                    <button
                                                        data-toggle="modal"
                                                        data-target="#chat-modal"
                                                        class="btn btn-outline-primary mx-1"
                                                        type="button"
                                                    >
                                                        {{ localizationStore.translate("chat.button.title") }}
                                                    </button>
                                                    <button
                                                        data-toggle="modal"
                                                        data-target="#top-up-modal"
                                                        class="btn btn-outline-primary"
                                                        type="button"
                                                    >
                                                        {{ localizationStore.translate("spin.purchase.button.text") }}
                                                    </button>
                                                </div>
                                                <div class="row">
                                                    <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                                                </div>
                                            </div>
                                            <div v-for="creditorRef in creditorRefs" :ref="creditorRef" hidden>
                                                <creditor-attorney-general-letter-1
                                                    v-if="$route.params.letter == letterStore.CREDITOR_ATTORNEY_GENERAL_LETTER_1"
                                                    :accounts='creditors[creditorRef].accounts'
                                                    :creditor='creditors[creditorRef].creditor'
                                                    :consumer-division-name="consumerDivisionName"
                                                    :attorney-general="attorneyGeneral"
                                                    :key="attorneyGeneral.id"
                                                />
                                                <creditor-notice-of-complaint v-if="$route.params.letter == 25" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <ca-notice-of-complaint v-else-if="$route.params.letter == 28" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-late-payment-dispute v-else-if="$route.params.letter == 55" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <initial-validation-dispute v-else-if="$route.params.letter == 64" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <collection-agency-computer-response v-else-if="$route.params.letter == 66" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <collection-agency-no-response v-else-if="$route.params.letter == 67" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <collection-agency-more-information-response v-else-if="$route.params.letter == 69" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <collection-agency-itemized-list-response v-else-if="$route.params.letter == 70" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <collection-agency-estoppel-by-silence v-else-if="$route.params.letter == 71" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <initial-verification-dispute v-else-if="$route.params.letter == 72" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-no-response v-else-if="$route.params.letter == 73" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-partial-verification-response v-else-if="$route.params.letter == 74" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-more-information-response v-else-if="$route.params.letter == 75" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-still-no-response v-else-if="$route.params.letter == 76" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-partial-verification-response-2 v-else-if="$route.params.letter == 77" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <debt-verified-response v-else-if="$route.params.letter == 78" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-collection-charge-off-validation-letter-1 v-else-if="$route.params.letter == letterStore.COLLECTION_DISPUTE_LETTER_1_A" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' :originalCreditedDate="originalCreditedDate"/>
                                                <creditor-collection-charge-off-validation-letter-2 v-else-if="$route.params.letter == letterStore.CREDITOR_COLLECTION_CHARGE_OFF_VALIDATION_LETTER_2" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-collection-charge-off-validation-letter-3 v-else-if="$route.params.letter == letterStore.CREDITOR_COLLECTION_CHARGE_OFF_VALIDATION_LETTER_3" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-charge-off-letter-1 v-else-if="$route.params.letter == letterStore.CREDITOR_CHARGE_OFF_LETTER_1" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <child-support-letter-1 v-else-if="$route.params.letter == letterStore.CHILD_SUPPORT_LETTER_1" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <child-support-letter-2 v-else-if="$route.params.letter == letterStore.CHILD_SUPPORT_LETTER_2" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <student-loan-letter-2 v-else-if="$route.params.letter == letterStore.STUDENT_LOAN_LETTER_2" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <student-loan-letter-3 v-else-if="$route.params.letter == letterStore.STUDENT_LOAN_LETTER_3" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-late-payment-1 v-else-if="$route.params.letter == letterStore.CREDITOR_LATE_PAYMENT_1" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-late-payment-2 v-else-if="$route.params.letter == letterStore.CREDITOR_LATE_PAYMENT_2" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-repossession-letter-1 v-else-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_1" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' />
                                                <creditor-repossession-letter-2 v-else-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_2" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' :originalCreditedDate="originalCreditedDate"/>
                                                <creditor-repossession-letter-3 v-else-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_3" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' :originalCreditedDate="originalCreditedDate" :originalCreditedDateTwo="originalCreditedDateTwo" :responseDate="responseDate"/>
                                                <creditor-repossession-letter-4 v-else-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_4" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' :letter4="letter4" :key="letter4.id" />
                                                <repossession-letter-1 v-else-if="$route.params.letter == letterStore.REPOSSESSION_LETTER_1" :accounts='creditors[creditorRef].accounts' :creditor='creditors[creditorRef].creditor' :repossession="repossession" :key="repossession.key" />
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="card-body">
                                        <div class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                                            <div class="alert-body">
                                                <i data-feather="info" class="mr-50 align-middle"></i>
                                                <span>
                                                    <template v-if="letterStore.isStudentLoan()">
                                                        Please Select at least one Account with Account Type Educational or Account Detail Educational
                                                    </template>
                                                    <template v-else-if="letterStore.isChildSupport()">
                                                        Please Select at least one Account with Account Type Child Support or Account Detail Child Support
                                                    </template>
                                                    <template v-else-if="letterStore.isRepossession()">
                                                        Please Select at least one Account with Account Type Auto Loan or Account Detail Auto Loan
                                                    </template>
                                                    <template v-else>
                                                        {{ localizationStore.translate("error.creditors") }}
                                                    </template>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="letter-form" class="modal show text-left" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <span class="text-primary text-md">Complaint Information</span>
                        </h4>
                        <button @click="closeModal('#letter-form')" type="button" class="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div
                            v-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_4"
                            class="row d-flex align-items-end"
                        >
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-name-of-court">
                                        COMPLETE NAME OF COURT
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="letter4.nameOfCourt"
                                        type="text"
                                        class="form-control"
                                        id="letter4-name-of-court"
                                        name="letter4-name-of-court"
                                        placeholder="COMPLETE NAME OF COURT"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-your-state">
                                        YOUR STATE
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="letter4.yourState"
                                        type="text"
                                        class="form-control"
                                        id="letter4-your-state"
                                        name="letter4-your-state"
                                        placeholder="YOUR STATE"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-case-number">
                                        Case Number
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="letter4.caseNumber"
                                        type="text"
                                        class="form-control required"
                                        id="letter4-case-number"
                                        name="letter4-case-number"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-county">
                                        County
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="letter4.county"
                                        type="text"
                                        class="form-control required"
                                        id="letter4-county"
                                        name="letter4-county"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-state">
                                        State
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="letter4.state"
                                        type="text"
                                        class="form-control required"
                                        id="letter4-state"
                                        name="letter4-state"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-deficiency-amount">
                                        Deficiency Amount from Plaintiff
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="letter4.deficiencyAmount"
                                        type="text"
                                        class="form-control"
                                        id="letter4-deficiency-amount"
                                        name="letter4-deficiency-amount"
                                        placeholder="Deficiency Amount from Plaintiff"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-dollar-limit-of-court">
                                        Dollar Limit Of Court
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="letter4.courtAmountLimit"
                                        type="text"
                                        class="form-control"
                                        id="letter4-dollar-limit-of-court"
                                        name="letter4-dollar-limit-of-court"
                                        placeholder="Dollar Limit Of Court"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-cost">
                                        Costs
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="letter4.cost"
                                        type="text"
                                        class="form-control"
                                        id="letter4-cost"
                                        name="letter4-cost"
                                        placeholder="Costs"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-email">
                                        Email of attorney or defendant’s rep of record
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="letter4.email"
                                        type="text"
                                        class="form-control"
                                        id="letter4-email"
                                        name="letter4-email"
                                        placeholder="Email of attorney or defendant’s rep of record"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-attorney-address">
                                        Full name and address of CRA’s attorney or representative of record
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="letter4.attorneyAddress"
                                        type="text"
                                        class="form-control"
                                        id="letter4-attorney-address"
                                        name="letter4-attorney-address"
                                        placeholder="Full name and address of CRA’s attorney or representative of record"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="date-sent">
                                        Date Sent
                                    </label>
                                    <input
                                        type="date"
                                        v-model="letter4.dateSent"
                                        class="form-control"
                                        name="date-sent"
                                        @change="updateLetter()"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
                            <button @click="closeModal('#letter-form')" type="button" class="btn btn-primary mr-sm-1 mb-1 mb-sm-0">Continue</button>
                            <button @click="closeModal('#letter-form')" type="button" class="btn btn-outline-primary">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- repossession letter 1 -->
        <div id="repossession-form" class="modal show text-left" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <span class="text-primary text-md">Complaint Information</span>
                        </h4>
                        <button @click="closeModal('#letter-form')" type="button" class="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div
                            v-if="$route.params.letter == letterStore.REPOSSESSION_LETTER_1"
                            class="row d-flex align-items-end"
                        >
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="oc-account">
                                        Original Creditor Account
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.oc_account"
                                        type="text"
                                        class="form-control"
                                        id="original-Creditor-account"
                                        name="original-Creditor-account"
                                        placeholder="Original Creditor Account"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="oc-account">
                                        Original Creditor Name
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.oc_name"
                                        type="text"
                                        class="form-control"
                                        id="oc-account-name"
                                        name="oc-account-name"
                                        placeholder="Original Creditor Name"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="collection-address">
                                        Original Creditor Address:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.oc_ddress"
                                        type="text"
                                        class="form-control"
                                        id="original-creditor-address"
                                        name="original-creditor-address"
                                        placeholder="Original Creditor Address"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="collection-city">
                                        Original Creditor City:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.oc_city"
                                        type="text"
                                        class="form-control"
                                        id="original-creditor-city"
                                        name="original-creditor-city"
                                        placeholder="Original Creditor City"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="collection-state">
                                        Original Creditor State:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.oc_state"
                                        type="text"
                                        class="form-control"
                                        id="original-creditor-state"
                                        name="original-creditor-state"
                                        placeholder="Original Creditor State"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="collection-zip-code">
                                        Collection Zip Code:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.oc_zip_code"
                                        type="text"
                                        class="form-control"
                                        id="original-creditor-zip-code"
                                        name="original-creditor-zip-code"
                                        placeholder="Original Creditor Zip Code"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="collection-agency">
                                        Collection Agency:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.collection_agency"
                                        type="text"
                                        class="form-control"
                                        id="collection-agency"
                                        name="collection-agency"
                                        placeholder="Collection Agency"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="collection-address">
                                        Collection Address:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.Address"
                                        type="text"
                                        class="form-control"
                                        id="collection-address"
                                        name="collection-address"
                                        placeholder="Collection Address"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="collection-city">
                                        Collection City:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.City"
                                        type="text"
                                        class="form-control"
                                        id="collection-city"
                                        name="collection-city"
                                        placeholder="Collection City"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="collection-state">
                                        Collection State:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.state"
                                        type="text"
                                        class="form-control"
                                        id="collection-state"
                                        name="collection-state"
                                        placeholder="Collection State"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="collection-zip-code">
                                        Collection Zip Code:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.zip_code"
                                        type="text"
                                        class="form-control"
                                        id="collection-zip-code"
                                        name="collection-zip-code"
                                        placeholder="Collection Zip Code"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="car-dealer">
                                        Car Dealer
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.CarDealer"
                                        type="text"
                                        class="form-control required"
                                        id="car-dealer"
                                        name="car-dealer"
                                        placeholder="Car Dealer"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="car-dealer-address">
                                        Car Dealer Address:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.CarDealerAddress"
                                        type="text"
                                        class="form-control"
                                        id="car-dealer-address"
                                        name="car-dealer-address"
                                        placeholder="Car Dealer Address"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="car-dealer-city">
                                        Car Dealer City:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.CarDealerCity"
                                        type="text"
                                        class="form-control"
                                        id="car-dealer-city"
                                        name="car-dealer-city"
                                        placeholder="Car Dealer City"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="car-dealer-state">
                                        Car Dealer State:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.CarDealerstate"
                                        type="text"
                                        class="form-control"
                                        id="car-dealer-state"
                                        name="car-dealer-state"
                                        placeholder="Car Dealer State"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="car-dealer-zip-code">
                                        Car Dealer Zip Code:
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.ZipCode"
                                        type="text"
                                        class="form-control"
                                        id="car-dealer-zip-code"
                                        name="car-dealer-zip-code"
                                        placeholder="Car Dealer Zip Code"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-county">
                                        Car Make
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.CarMake"
                                        type="text"
                                        class="form-control required"
                                        id="car-make"
                                        name="car-make"
                                        placeholder="Car Make"
                                    />
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="letter4-state">
                                        Car Model
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.CarModel"
                                        type="text"
                                        class="form-control required"
                                        id="car-model"
                                        name="car-model"
                                        placeholder="Car Model"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="repossession-vin">
                                        VIN
                                    </label>
                                    <input
                                        @input="updateLetter()"
                                        v-model="repossession.vin"
                                        type="text"
                                        class="form-control"
                                        id="repossession-vin"
                                        name="repossession-vin"
                                        placeholder="VIN"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="repossession-date-sent">
                                        Repo Date
                                    </label>
                                    <input
                                        type="date"
                                        v-model="repossession.repoDate"
                                        class="form-control"
                                        name="repossession-date"
                                        @change="updateLetter()"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="repossession-date-sent">
                                        Date Sent
                                    </label>
                                    <input
                                        type="date"
                                        v-model="repossession.dateSent"
                                        class="form-control"
                                        name="repossession-date-sent"
                                        @change="updateLetter()"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-12">
                                <div class="form-group">
                                    <label for="resold-date">
                                        Resold Date
                                    </label>
                                    <input
                                        type="date"
                                        v-model="repossession.resoldDate"
                                        class="form-control"
                                        name="resold-date"
                                        @change="updateLetter()"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
                            <button @click="closeModal('#repossession-form')" type="button" class="btn btn-primary mr-sm-1 mb-1 mb-sm-0">Continue</button>
                            <button @click="closeModal('#repossession-form')" type="button" class="btn btn-outline-primary">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
  import { ref, reactive, computed, nextTick } from 'vue'
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  import { useReportStore } from '../../stores/ReportStore.js'
  import { useUserStore } from '../../stores/UserStore.js'
  import { useLetterStore } from '../../stores/LetterStore.js'
  import { usePlanStore } from '../../stores/PlanStore.js'
  import { useSettingStore } from '../../stores/SettingStore.js'
  import moment from 'moment';
  import Editor from '@tinymce/tinymce-vue'
  import AttorneyGeneralLetter1 from './creditor/attorney_general/Letter1.vue'
  import CreditorCollectionChargeOffValidationLetter1 from './CreditorCollectionChargeOffValidationLetter1.vue'
  import CreditorCollectionChargeOffValidationLetter2 from './CreditorCollectionChargeOffValidationLetter2.vue'
  import CreditorCollectionChargeOffValidationLetter3 from './CreditorCollectionChargeOffValidationLetter3.vue'
  import CreditorLatePayment1 from './CreditorLatePayment1.vue'
  import CreditorLatePayment2 from './CreditorLatePayment2.vue'
  import Letter1 from './creditor/repossession/Letter1.vue'
  import Letter2 from './creditor/repossession/Letter2.vue'
  import Letter3 from './creditor/repossession/Letter3.vue'
  import Letter4 from './creditor/repossession/Letter4.vue'
  import CreditorChargeOffLetter1 from './CreditorChargeOffLetter1.vue'
  import ChildSupportLetter1 from './ChildSupportLetter1.vue'
  import ChildSupportLetter2 from './ChildSupportLetter2.vue'
  import StudentLoanLetter2 from './StudentLoanLetter2.vue'
  import StudentLoanLetter3 from './StudentLoanLetter3.vue'
  import { BPopover } from 'bootstrap-vue-3'
  import lodash from 'lodash'
  import { closeModal, hideModal, openModal } from '../../utilities/_helpers'
  export default {
    props: {
        csrf: {
            type: String
        },
        propCreditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        'editor': Editor,
        'creditor-attorney-general-letter-1': AttorneyGeneralLetter1,
        'creditor-collection-charge-off-validation-letter-1': CreditorCollectionChargeOffValidationLetter1,
        'creditor-collection-charge-off-validation-letter-2': CreditorCollectionChargeOffValidationLetter2,
        'creditor-collection-charge-off-validation-letter-3': CreditorCollectionChargeOffValidationLetter3,
        'creditor-late-payment-1': CreditorLatePayment1,
        'creditor-late-payment-2': CreditorLatePayment2,
        'creditor-repossession-letter-1': Letter1,
        'creditor-repossession-letter-2': Letter2,
        'creditor-repossession-letter-3': Letter3,
        'creditor-repossession-letter-4': Letter4,
        'creditor-charge-off-letter-1': CreditorChargeOffLetter1,
        'child-support-letter-1': ChildSupportLetter1,
        'child-support-letter-2': ChildSupportLetter2,
        StudentLoanLetter2,
        StudentLoanLetter3,
    },
    setup(props) {
        return {
            creditBureaus: props.propCreditBureaus,
            consumerDivisionName: ref(null),
            editorRef: ref(null),
            date: ref(moment().format('LL')),
            localizationStore: useLocalizationStore(),
            reportStore: useReportStore(),
            userStore: useUserStore(),
            letterStore: useLetterStore(),
            planStore: usePlanStore(),
            settingStore: useSettingStore(),
            email: ref(null),
            activeTab: ref(null),
            creditors: reactive({}),
            creditorRefs: reactive([]),
            routes:ref([]),
            userInfo:reactive({}),
            checkbox:ref(false),
            attorneyGeneral: reactive({
                id: 1,
                name: null,
                address: null,
                city: null,
                state: null,
                zipcode: null,
                fax: null,
            }),
            letter4: reactive({
                id: 1,
                nameOfCourt: null,
                yourState: null,
                caseNumber: null,
                county: null,
                state: null,
                deficiencyAmount: null,
                courtAmountLimit: null,
                cost: null,
                email: null,
                attorneyAddress: null,
                dateSent: null,
            }),
            repossession: reactive({
                key:1,
                oc_account: null,
                oc_name:null,
                oc_ddress:null,
                oc_city:null,
                oc_state:null,
                oc_zip_code:null,
                collection_agency: null,
                Address: null,
                City: null,
                state: null,
                zip_code: null,
                CarDealer: null,
                CarDealerAddress: null,
                CarDealerCity: null,
                CarDealerstate: null,
                ZipCode: null,
                CarMake: null,
                CarModel: null,
                vin: null,
                repoDate:null,
                dateSent: null,
                resoldDate: null,
            }),
            lodash: lodash,
            closeModal,
            openModal,
            originalCreditedDate: ref(null),
            originalCreditedDateTwo: ref(null),
            responseDate: ref(null),
        };
        
    },
    watch: {
        'userStore.user'(value) {
            if (value != null) {
                this.email = value.email;
                this.userInfo = value;
                if (!this.reportStore.reports[this.email]) {
                    this.reportStore.getReport();
                }
                let $this = this;
                let selectedCreditorAccounts = $this.reportStore.getSelectedCreditorAccounts($this.reportStore.getFilter());
                _.forEach(selectedCreditorAccounts, function(creditor) {
                    let furnisherName = $this.reportStore.getCreditorDetail(creditor[4].creditor).creditor_name;
                    if (furnisherName) {
                        furnisherName = _.camelCase(furnisherName);
                        $this.creditorRefs.push(furnisherName);
                        if (_.isUndefined($this.creditors[furnisherName])) {
                            $this.creditors[furnisherName] = {
                                accounts: [],
                                creditor: $this.reportStore.getCreditorDetail(creditor[4].creditor),
                                ref: null
                            };
                        }
                        let accountDetail = $this.reportStore.getAccountDetail(creditor);
                        accountDetail.reason = creditor[4].reason;
                        $this.creditors[furnisherName].accounts.push(accountDetail);
                    }
                });
                $this.activeTab = _.head($this.creditorRefs);
            }
        },
    },
    created() {
    },
    mounted() {
        const $this = this;
        const letterSpinUrl = this.$router.resolve({
            name: 'spin-letter',
        });
        $this.routes = {
            'letterSpinUrl':letterSpinUrl.href
        };
        nextTick(() => {
            _.forEach($this.$refs, function(ref, key) {
                if (_.has($this.creditors, key)) {
                    $this.creditors[key].ref = ref[0].innerHTML;
                }
            });
            if (_.includes([$this.letterStore.CREDITOR_REPOSSESSION_LETTER_4], $this.$route.params.letter)) {
                $this.openModal('#letter-form');
            }
            if (_.includes([$this.letterStore.REPOSSESSION_LETTER_1], $this.$route.params.letter)) {
                $this.openModal('#repossession-form');
            }
        });
        if(!_.isEmpty(this.userStore.user)){
            $this.userInfo = this.userStore.user;
            $this.email = this.userStore.user.email;
            if (!this.reportStore.reports[this.email]) {
                this.reportStore.getReport();
            }
            let selectedCreditorAccounts = $this.reportStore.getSelectedCreditorAccounts($this.reportStore.getFilter());
            _.forEach(selectedCreditorAccounts, function(creditor) {
                let furnisherName = $this.reportStore.getCreditorDetail(creditor[4].creditor).creditor_name;
                if (furnisherName) {
                    furnisherName = _.camelCase(furnisherName);
                    $this.creditorRefs.push(furnisherName);
                    if (_.isUndefined($this.creditors[furnisherName])) {
                        $this.creditors[furnisherName] = {
                            accounts: [],
                            creditor: $this.reportStore.getCreditorDetail(creditor[4].creditor),
                            ref: null
                        };
                    }
                    let accountDetail = $this.reportStore.getAccountDetail(creditor);
                    accountDetail.reason = creditor[4].reason;
                    $this.creditors[furnisherName].accounts.push(accountDetail);
                }
            });
            $this.activeTab = _.head($this.creditorRefs);
        }else{
            $this.userStore.fetchUser();
        }
    },
    updated() {
    },
    computed: {
    },
    methods: {
        submit() {
            const route = this.$router.resolve({
                name: 'create-letter',
                params: {
                    letter: this.$route.params.letter,
                    client: this.$route.params.client,
                    team: this.$route.params.team
                }
            }),
            $this = this,
            payload = {
                multipe_letters: true,
                letters: []
            };
            _.forEach($this.creditors, function(creditor) {
                let accounts = [];
                _.forEach(creditor.accounts, function(account) {
                    accounts.push({
                        'id': account.id,
                        'reason': account.reason
                    });
                });
                payload.letters.push({
                    letter_id: $this.letterStore.getId($this.$route.params.letter),
                    credit_bureau_name: creditor.creditor.creditor_name,
                    letter_preview: creditor.ref,
                    accounts: accounts,
                    append_affidavit: $this.checkbox,
                });
            });
            axios.post(route.href, payload)
            .then(function (response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                setTimeout(() => {
                    if($this.userStore.user.isDIY){
                        $this.$router.push({ name: 'disputes-report' });
                        return;
                    }
                    window.location.href = response.data.data.url;
                }, 3000)
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        spin() {
            this.$refs.spinner.spin(tinymce.get(this.activeTab))
        },
        changeCheckbox(){
            this.checkbox = !this.checkbox
        },
        updateLetter() {
            this.attorneyGeneral.id++;
            this.letter4.id++;
            const $this = this;
            setTimeout(() => {
                _.forEach($this.$refs, function(ref, key) {
                    if (_.has($this.creditors, key)) {
                        $this.creditors[key].ref = ref[0].innerHTML;
                    }
                });
            }, 200);
        }
    }
  };
</script>
